import script from "./process.vue?vue&type=script&setup=true&lang=js"
export * from "./process.vue?vue&type=script&setup=true&lang=js"

import "./process.vue?vue&type=style&index=0&id=53f0450f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53f0450f"]])

export default __exports__